<template lang="pug">
  div.n-accordion
    .n-accordion--header(:class="readonly && 'disabled'" @click="onOpenAccordion")
      .toggle-icon(:class="isOpen && 'open'")
        a: i.fo.fo-arrow-down(v-if="!readonly")
      slot(name="header")

    .n-accordion--content(v-if="!readonly" :class="isOpen && 'open'")
      slot(name="content")

</template>

<script>

export default {
  name: 'n-accordion-chart',

  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    isOpen: false
  }),

  methods: {
    onOpenAccordion() {
      this.isOpen = !this.isOpen;
      this.$emit('selected', this.isOpen);
    }
  }
};
</script>

<style lang="scss">
.n-accordion {
  position: relative;
  font-weight: 400;

  &--header {
    position: relative;
    display: flex;
    border-bottom: 1px solid #E9E9E9;

    .toggle-icon {
      position: absolute;
      left: 10px;
      top: 0px;
      bottom: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      pointer-events: none;
      transform: rotate(0deg);
      transition: all .3s ease;

      .fo-arrow-down:before {
        color: #ff0000;
        font-size: 14px;
      }

      &.open {
        transform: rotate(180deg);

        .fo-arrow-down:before {
          color: #fff;
        }
      }
    }

    &.disabled {
      pointer-events: none;
    }
  }

  &--content {
    max-height: 0;
    overflow: hidden;
    transition: max-height .3s ease;

    &.open {
      max-height: 100vh;
    }
  }

  &.highlighted {
    .n-accordion--header {
      .toggle-icon.open  .fo-arrow-down:before {
        color: #666;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/n-accordion.vue